module.exports = __webpack_public_path__ + "static/img/4.99fefdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/4.png
// module id = 9uVk
// module chunks = 12